import React, { useContext, useEffect, useRef, useState } from "react";
import "../../Dashboard/View_List/View_List.css";
import "./Table.css";
// import Add from "./Add";
// import Edit from "./Edit";
import Custom_Confirm_Modal from "../../Common_Component/Common_Modal/Custom_Confirm_Modal/Custom_Confirm_Modal";
import Edit_Bet_Modal from "../../Common_Component/Common_Modal/Edit_Bet_Modal/Edit_Bet_Modal";
import { Button, Form, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrash } from "@fortawesome/free-solid-svg-icons";
import { findAll, deleteBet, editBet } from "../../../utils/apis/matka/playedGame/played_game";

import {
  formatDateTime,
  Per_Page_Dropdown,
  users_type,
} from "../../../utils/common";
import Pagination_holder from "../../Common_Component/Pagination_holder/Pagination_holder";
import CustomPaginate from "../../Common_Component/CustomPaginate/CustomPaginate";
import { Context } from "../../../utils/context";
import { Country, marketWinBid, matkaGames, State, stores } from "../../../utils/apis/common/index";
import { formatDate } from "../../../utils/common";
import Select from "react-select";
import Heading_Holder from "../../Common_Component/Heading_Holder/Heading_Holder";
import ModalSave from "../../Common_Component/Common_Modal/Successfull_Modal/ModelSave";

const Tables = () => {
  const params = new URLSearchParams(window.location.search);

  const id = params.get("id");
  const store_id = params.get("store_id");
  const only_win = params.get("only_win") === "true";

  const { UnauthorizedLogOut, Select2Data, IMG_URL, usertype } =
    useContext(Context);

  const today = new Date();

  const formattedDate =
    today.getFullYear().toString() +
    String(today.getMonth() + 1).padStart(2, "0") +
    String(today.getDate()).padStart(2, "0");


  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });
  const marqueeRef = useRef(null);
  const [modalConfirmShow, setModalConfirmShow] = useState(false);
  const [confirmModalData, setConfirmModalData] = useState(null);


  const [editBetModalData, setEditBetModalData] = useState(false);


  const [modalShow, setModalShow] = useState(false);
  const [modalEditShow, setModalEditShow] = useState(false);

  const [data, setData] = useState([]);
  const [summaryData, setSummaryData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(50);
  const [search, setSearch] = useState(formattedDate);
  const [reset, setReset] = useState();
  const [changeStatus, setChangeStatus] = useState();
  const [option, setOption] = useState();
  const [searchDateTo, setSearchDateTo] = useState("");

  const [name, setName] = useState("");
  const [contact_no, setContact_no] = useState("");
  const [store, setStore] = useState();
  const [market, setMarket] = useState();
  const [matkaGame, setMatkaGame] = useState();
  const todaysearch = new Date().toISOString().split("T")[0];
  const [searchDateFrom, setSearchDatefrom] = useState(todaysearch);
  const [onlyWin, setOnlyWin] = useState(only_win);
  const [type, setSearchType] = useState("open");
  const [searchStore, setSearchStore] = useState(null);


  const getMatkaGames = async () => {
    const response = await matkaGames();

    await setMatkaGame(response?.data?.data);
  };

  const getStores = async () => {
    const response = await stores();

    await setStore(response?.data?.data?.data);
  };

  const getMarketWinBid = async () => {
    const response = await marketWinBid();

    await setMarket(response?.data?.data);


  };

  console.log(market);



  const handleDeleteBet = async () => {
    try {

      setModalConfirmShow(false);
      if (confirmModalData) {
        const response = await deleteBet(confirmModalData);
        console.log(response, "delete response");
        await setShowModal({
          code: response.data?.code,
          message: response.data.data.message,
        });
        setTimeout(() => {
          setShowModal(0);
        }, 2000);
        await getDataAll();
      }
    } catch (error) {
      console.error(error.message);
      await UnauthorizedLogOut(error);
    }
  };


  const handleEditBet = async (betData) => {
    try {

      console.log(betData, "betData");
      const response = await editBet(betData?.id, { bit_place: betData?.bit_place });
      console.log(response, "edit response");
      await setShowModal({
        code: response.data?.code,
        message: response.data.data.message,
      });
      setTimeout(() => {
        setEditBetModalData(0);
        setShowModal(0);
      }, 2000);
      await getDataAll();

    } catch (error) {
      console.error(error.message);
      await UnauthorizedLogOut(error);
    }
  };


  const getDataAll = async () => {
    try {

      if (searchDateFrom && searchStore?.value && type) {
        const response = await findAll(
          currentPage,
          perPage,
          searchDateFrom,
          searchStore?.value,
          name,
          contact_no,
          id,
          onlyWin,
          type,
        );

        await setData(response?.data?.data);
        setCurrentPage(response?.data?.data?.current_page);
        setperPage(response?.data?.data?.per_page);
        // setSearch(response?.data?.data?.search_name);

        setOption(await Per_Page_Dropdown(response?.data?.data?.total));
      }

    } catch (error) {
      console.error(error.message);
      await UnauthorizedLogOut(error);
    }
  };

  useEffect(() => {
    getStores();
    getMarketWinBid();
    getMatkaGames();
  }, []);

  useEffect(() => {
    if (store) {
      getDataAll();
    }
  }, [
    store,
    currentPage,
    perPage,
    reset,
    modalShow,
    modalEditShow,
    search,
    searchDateTo,
    searchDateFrom,
    name,
    contact_no,
    type,
    searchStore,
    onlyWin,
  ]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handleDateChange = (date) => {
    setSearchDateTo(date); // Update the state with the selected date
  };

  const getToday = () => {
    const d = new Date();
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const formatDateForPeriod = (date) => date.replaceAll("-", "");

  const [periodPrefix, setPeriodPrefix] = useState(formattedDate);
  const [periodSuffix, setPeriodSuffix] = useState("");

  useEffect(() => {
    if (searchDateFrom) {
      setPeriodPrefix(formatDateForPeriod(searchDateFrom));
      setPeriodSuffix(""); // reset suffix when date changes
    }
  }, [searchDateFrom]);
  const sessionOptions = [
    { value: "open", label: "Open" },
    { value: "close", label: "Close" },
  ];

  useEffect(() => {
    if (store && store_id) {
      const selectedStore = store.find(
        (item) => String(item.value) === String(store_id),
      );

      setSearchStore(selectedStore || null);
    }
  }, [store, store_id]);


  useEffect(() => {
    const marquee = document.querySelector(".market-marquee");

    if (!marquee) return;

    let animationFrame;
    let isDragging = false;
    let startX = 0;
    let startScrollLeft = 0;

    const speed = 0.5;

    const autoScroll = () => {
      if (!isDragging) {
        marquee.scrollLeft += speed;

        // Reset when reaching the end
        if (
          marquee.scrollLeft + marquee.clientWidth >=
          marquee.scrollWidth
        ) {
          marquee.scrollLeft = 0;
        }
      }

      animationFrame = requestAnimationFrame(autoScroll);
    };

    const handleMouseDown = (e) => {
      isDragging = true;
      startX = e.pageX - marquee.offsetLeft;
      startScrollLeft = marquee.scrollLeft;
    };

    const handleMouseMove = (e) => {
      if (!isDragging) return;

      e.preventDefault();

      const x = e.pageX - marquee.offsetLeft;
      const walk = (x - startX) * 1.5;

      marquee.scrollLeft = startScrollLeft - walk;
    };

    const handleMouseUp = () => {
      isDragging = false;
    };

    marquee.addEventListener("mousedown", handleMouseDown);
    marquee.addEventListener("mousemove", handleMouseMove);
    marquee.addEventListener("mouseup", handleMouseUp);
    marquee.addEventListener("mouseleave", handleMouseUp);

    animationFrame = requestAnimationFrame(autoScroll);

    return () => {
      cancelAnimationFrame(animationFrame);

      marquee.removeEventListener("mousedown", handleMouseDown);
      marquee.removeEventListener("mousemove", handleMouseMove);
      marquee.removeEventListener("mouseup", handleMouseUp);
      marquee.removeEventListener("mouseleave", handleMouseUp);
    };
  });

  return (
    <>
      <section className="View_List">
        <Heading_Holder headingText={"Matka Played Game History"} />
        <div className="search-bar-holder ">
          <Form>
            <div className="row align-items-end">
              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5">
                <Form.Group className="form-field">
                  <Form.Label className="formlbb">Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={searchDateFrom}
                    min="0001-01-01"
                    max="9999-12-31" // ✅ ensures only 4-digit year
                    onChange={(e) => {
                      const value = e.target.value;

                      // optional safety (can even remove this) 77777777777777777
                      if (!value) return;

                      const year = value.split("-")[0];
                      if (year.length !== 4) return;

                      setSearchDatefrom(value);
                    }}
                  />
                </Form.Group>
              </div>

              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5">
                <Form.Group className="form-field">
                  <Form.Label className="formlbb">User Name</Form.Label>

                  <Form.Control
                    type="text"
                    placeholder="name"
                    value={name}
                    onChange={(e) => {
                      setName(e.target.value);
                    }}
                  />
                </Form.Group>
              </div>

              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5">
                <Form.Group className="form-field">
                  <Form.Label className="formlbb">User Number</Form.Label>

                  <Form.Control
                    type="text"
                    placeholder="Mobile Number"
                    value={contact_no}
                    onChange={(e) => {
                      setContact_no(e.target.value);
                    }}
                  />
                </Form.Group>
              </div>

              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5">
                <Form.Group className="form-field">
                  <Form.Label className="formlbb">Session</Form.Label>

                  <Select
                    isSearchable={false}
                    options={sessionOptions}
                    value={sessionOptions.find(
                      (option) => option.value === type,
                    )}
                    placeholder="Select Session"
                    onChange={(selected) =>
                      setSearchType(selected ? selected.value : "")
                    }
                  />
                </Form.Group>
              </div>

              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5">
                <Form.Group className="form-field">
                  <Form.Label className="formlbb">Store</Form.Label>

                  <Select
                    isSearchable
                    options={store}
                    value={searchStore}
                    placeholder="Select Store"
                    onChange={(e) => {
                      setSearchStore(e);
                    }}
                  />
                </Form.Group>
              </div>


              {/* <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5  col-holder">
                <br></br>
                <Button
                  type="button"
                  className="search-btn mt-2"
                  onClick={getDataAll}>
                  Search
                </Button>
              </div> */}

              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5  col-holder">
                <br></br>
                <Button
                  type="button"
                  className="search-btn mt-2"
                  onClick={getDataAll}>
                  Refresh
                </Button>
              </div>

              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5   col-holder">
                <br></br>
                <Button
                  type="button"
                  className="reset-btn mt-2"
                  onClick={() => {
                    setName("");
                    setSearchDatefrom("");
                    setSearchStore("");
                    setContact_no("");
                    setSearchType("");
                    setReset(!reset);
                  }}>
                  Reset
                </Button>
              </div>
              <hr />
            </div>
          </Form>
        </div>

        {/* MARKET SUMMARY MARQUEE */}
        {market?.data?.length > 0 && (
          <div className="market-summary-wrapper">

            {/* Moving Market List */}
            <div
              className="market-marquee"
              ref={marqueeRef}
            >
              <div className="market-marquee-track">

                {[...market.data, ...market.data].map((item, index) => {
                  const bidAmount = Number(item?.bid_amount ?? 0);
                  const winAmount = Number(item?.win_amount ?? 0);
                  const profitLoss = bidAmount - winAmount;

                  return (
                    <div
                      className={bidAmount > 0 ? "market-summary-item-bid" : "market-summary-item"}
                      key={`${item?.label}-${index}`}
                    >
                      {/* Market Name */}
                      <div className="market-name">
                        {item?.label || "-"}
                      </div>

                      {/* Result */}
                      <div className="market-result">
                        {item?.result
                          ? `${item?.result?.open_time ?? "*"}${item?.result?.close_time ?? "*"}`
                          : "***-**-***"}
                      </div>

                      {/* Bid */}
                      <div className="market-bid">
                        Bid: ₹{bidAmount.toLocaleString("en-IN")}
                      </div>

                      {/* Win */}
                      <div className="market-win">
                        Win: ₹{winAmount.toLocaleString("en-IN")}
                      </div>

                      {/* Profit / Loss */}
                      <div
                        className={
                          profitLoss >= 0
                            ? "market-profit"
                            : "market-loss"
                        }
                      >
                        {profitLoss >= 0 ? "Profit" : "Loss"}: ₹
                        {Math.abs(profitLoss).toLocaleString("en-IN")}
                      </div>

                      <span className="market-separator">|</span>
                    </div>
                  );
                })}

              </div>
            </div>

            {/* Fixed Total */}
            <div className="market-total">

              <div>
                <span>Total Bid</span>
                <strong>
                  ₹{Number(market?.totalBid ?? 0).toLocaleString("en-IN")}
                </strong>
              </div>

              <div>
                <span>Total Win</span>
                <strong>
                  ₹{Number(market?.totalWin ?? 0).toLocaleString("en-IN")}
                </strong>
              </div>

              <div>
                <span>Total P/L</span>
                {(() => {
                  const totalPL =

                    Number(market?.totalBid ?? 0) - Number(market?.totalWin ?? 0);

                  return (
                    <strong
                      className={
                        totalPL >= 0
                          ? "total-profit"
                          : "total-loss"
                      }
                    >
                      {totalPL >= 0 ? "+" : "-"}₹
                      {Math.abs(totalPL).toLocaleString("en-IN")}
                    </strong>
                  );
                })()}
              </div>

            </div>

          </div>
        )}
        <div className="row">
          <div className="col-xl-12 col-lg-12 col-md-12">
            <div className="user-list-table">
              {/* <Banner_List_Table /> */}

              <div className="data-table-holder">
                <Table
                  responsive
                  bordered
                  striped
                  className="game-bet-table"
                >
                  <tbody>
                    {matkaGame && matkaGame.length > 0 ? (
                      matkaGame.map((game, index) => {
                        const gameData = data.gameData?.[index];
                        const bitDetails = gameData?.bit_details || [];

                        return (
                          <tr key={game.id}>
                            {/* Game Name + Total */}
                            <td>
                              <strong className="text-warning">{game.name}</strong>
                              <br />
                              <span className="text-warning">
                                <strong>
                                  Total: {game?.id == 18 ? (gameData?.total_bids || 0) / 5 : gameData?.total_bids || 0}
                                </strong>
                              </span>
                            </td>

                            {/* User Bets */}
                            {bitDetails.length > 0 ? (
                              bitDetails.map((d, bitIndex) => (
                                <td key={d.id || bitIndex} className="p-2">
                                  <div className="bet-card">

                                    {/* User */}
                                    <div className="bet-user">
                                      <i className="fa fa-user-circle me-1"></i>
                                      <strong>{d?.User?.name || '-'}</strong>
                                    </div>

                                    {/* Bet Place */}
                                    <div className="bet-place">
                                      {d?.bit_place || '-'}
                                    </div>

                                    {/* Actions */}
                                    <div className="bet-actions">
                                      {!d?.matka_win_id && (
                                        <>
                                          <button
                                            type="button"
                                            className="bet-btn bet-edit"
                                            onClick={() => setEditBetModalData({
                                              ...d
                                            })}
                                            title="Edit Bet"
                                          >
                                            <i className="fa fa-edit"></i>
                                            <span>Edit</span>
                                          </button>

                                          <button
                                            type="button"
                                            className="bet-btn bet-delete"
                                            onClick={() => {
                                              setConfirmModalData(d?.id);
                                              setModalConfirmShow(true);
                                            }}
                                            title="Delete Bet"
                                          >
                                            <i className="fa fa-trash"></i>
                                            <span>Delete</span>
                                          </button>
                                        </>
                                      )}

                                    </div>

                                  </div>
                                </td>
                              ))
                            ) : (
                              <td className="text-center">
                                <span className="text-muted">No Data</span>
                              </td>
                            )}
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="9" className="text-center">
                          No Data
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>


              </div>
            </div>
          </div>
        </div>
      </section>

      <Custom_Confirm_Modal
        heading={"Confirm Bet Revert"}
        title={"Are you sure you want to revert this bet?"}
        show={modalConfirmShow}
        handleFunction={handleDeleteBet}
        onHide={() => setModalConfirmShow(false)}
      />

      <Edit_Bet_Modal
        heading={"Edit Bet"}
        show={editBetModalData}
        handleFunction={handleEditBet}
        onHide={() => setEditBetModalData(false)}
      />

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};
export default Tables;
